import { render, staticRenderFns } from "./addressSeePopup.vue?vue&type=template&id=5bc1d7c6&scoped=true"
import script from "./addressSeePopup.vue?vue&type=script&lang=js"
export * from "./addressSeePopup.vue?vue&type=script&lang=js"
import style0 from "./addressSeePopup.vue?vue&type=style&index=0&id=5bc1d7c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1d7c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc1d7c6')) {
      api.createRecord('5bc1d7c6', component.options)
    } else {
      api.reload('5bc1d7c6', component.options)
    }
    module.hot.accept("./addressSeePopup.vue?vue&type=template&id=5bc1d7c6&scoped=true", function () {
      api.rerender('5bc1d7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myBoardChild/child/addressSeePopup.vue"
export default component.exports